import { Link } from 'react-router-dom';
import { products } from '@/mocks/products';

interface Props {
  currentId: number;
}

const ProductDetailRelated = ({ currentId }: Props) => {
  const related = products.filter((p) => p.id !== currentId).slice(0, 3);

  return (
    <section className="py-20 bg-[#f8f9fb]">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-6 h-0.5 bg-[#1a2b4a]" />
          <span className="text-xs font-semibold text-[#1a2b4a] tracking-[0.2em] uppercase">Other Products</span>
        </div>
        <h2 className="text-2xl font-bold text-[#1a2b4a] mb-10">다른 제품 보기</h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
          {related.map((product) => (
            <Link
              key={product.id}
              to={`/product/${product.id}`}
              className="bg-white rounded-xl overflow-hidden border border-gray-100 group hover:-translate-y-1.5 transition-transform duration-300 cursor-pointer block"
            >
              <div className="w-full h-52 bg-gray-50 flex items-center justify-center overflow-hidden">
                <img
                  src={product.image}
                  alt={product.name}
                  className="w-full h-full object-contain p-4 group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <span className="text-xs text-gray-400 mb-1 block">{product.category}</span>
                <h3 className="text-sm font-bold text-[#1a2b4a] mb-2">{product.name}</h3>
                <span className="inline-flex items-center gap-1 text-xs font-semibold text-[#1a2b4a] group-hover:gap-2 transition-all duration-200">
                  자세히 보기
                  <i className="ri-arrow-right-line" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProductDetailRelated;
